export default __webpack_public_path__ + "static/media/usage_map.7cdc1e1e.png";